import * as React from 'react';

type StrategyCardProps = {
  children?: React.ReactNode;
  title: string;
};

const StrategyCard = ({ children, title }: StrategyCardProps) => {
  return (
    <div className='flex flex-col justify-around min-h-42 wrap-normal bg-white rounded-16 shadow-[2px_2px_8px_0px_rgba(0,0,0,0.25)] py-8 px-4'>
      <h3 className='mb-4'>{title}</h3>
      <div className='text-[#666666] font-normal text-sm'>{children}</div>
    </div>
  );
};

StrategyCard.displayName = 'StrategyCard';

export default StrategyCard;
